import "./UserCard.scss";
import Icon from "../../UI/Icon/Icon";
import { userSkills, userContacts } from "./UserCardData";

const UserCard = (props) => {
  const downloadCV = () => {
    // console.log("Download CV");
    const link = document.createElement("a");
    link.href = "./files/resume.pages"; // файл лежит в public/
    link.download = "resume.pages"; // имя сохраняемого файла
    link.click();
  };

  return (
    <div className="userCard">
      <div className="userCard__wrapper">
        <div className="userCard__top">
          <div className="userCard__photo">
            <picture>
              {props.imageUrlWebp && <source srcSet={props.imageUrlWebp} type="image/webp"></source>}
              <img
              src={props.imageUrl}
              alt="Мое фото"
              className="userCard__photo-img"
            />
            </picture>
            
          </div>
          <div className="userCard__text">
            <span className="userCard__title">{props.userName}</span>
            <span className="userCard__subtitle">{props.proffesion}</span>
          </div>
        </div>
        <div className="userCard__middle">
          <ul className="userCard__list-contacts">
            {userContacts.map(({ key, idIcon, width, height, label, link }) => (
              <li className="userCard__item-contacts" key={key}>
                <a href={link} className="userCard__link">
                  <Icon
                    className="userCard__link-icon"
                    id={idIcon}
                    width={width}
                    height={height}
                  />
                  <span className="userCard__link-text">{label}</span>
                </a>
              </li>
            ))}
          </ul>
          <ul className="userCard__list-skills">
            {userSkills.map((text, index) => (
              <li className="userCard__item-skills" key={index}>
                {text}
              </li>
            ))}
          </ul>
        </div>
        <button
          className="userCard__button glowbutton"
          type="button"
          onClick={downloadCV}
        >
          <span className="userCard__button-text">Скачать резюме</span>
          <Icon
            className="userCard__button-icon"
            id="icon-download"
            width="20"
            height="20"
          />
        </button>
      </div>
    </div>
  );
};

export default UserCard;
